var map = {
	"./bronze.png": 2476,
	"./gold.png": 6454,
	"./image.png": 8369,
	"./logo-oei-fli-fwi.png": 2126,
	"./logo.png": 3153,
	"./logo_fli.png": 3219,
	"./logopptx.png": 9709,
	"./silver.png": 3823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;